<ng-container>
  <div class="header">
    <h2>Are you sure?</h2>
  </div>
  <form [formGroup]="noteForm" *ngIf="noteForm">
    <div class="row">

      <div class="col-md-12 mb-4">
        Are you sure you want to remove additional coverage for order id : <strong> {{title}}</strong>
        </div>

      <div class="col-md-12 d-flex">
        <button
          class="custom-btn mr-3"
          (click)="submitForm()"
        >

          {{
            editMode && isLoading
              ? "Removing..."
              :"Remove"

          }}
          <!-- Add -->
        </button>
        <button class="custom-btn" mat-dialog-close>Cancel</button>
      </div>
    </div>
  </form>
</ng-container>
